<template>
  <div id="profile-general-module" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden body-module-height">
    <bds-scroll-area component-class="content-scroll-area">
      <vx-card no-shadow>
        <vs-input type="password" class="w-full mb-base" label-placeholder="Old Password" v-model="old_password" />
        <vs-input type="password" class="w-full mb-base" label-placeholder="New Password" v-model="new_password" />
        <vs-input type="password" class="w-full mb-base" label-placeholder="Confirm Password" v-model="confirm_new_password" />

        <!-- Save & Reset Button -->
        <div class="flex-wrap items-center justify-start">
          <vs-button class="ml-auto mt-2" type="border" color="warning" @click="changePassword">Change Password</vs-button>
        </div>
      </vx-card>
    </bds-scroll-area>
  </div>
</template>

<script>
import ProfileService from '@/services/Profile.service';
import UserService from '@/services/User.service';
import { showErrorPopup, showSuccessNotify } from '@/helpers/functionsHelpers';

export default {
  name: 'user-change-password',
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      old_password: '',
      new_password: '',
      confirm_new_password: '',
    };
  },
  methods: {
    changePassword() {
      if (this.old_password.length === 0) {
        //TODO Aplicar validation dos campos
      }

      if (this.new_password !== this.confirm_new_password) {
        this.$alma.dialogConfirm({
          isOkModal: true,
          title: this.$t('pages.users.changePassword.title'),
          textBody: this.$t('pages.users.changePassword.password1DifferentPassword2'),
        });
        return;
      }

      const payload = {
        userId: this.userId,
        oldPass: this.old_password,
        newPass1: this.new_password,
        newPass2: this.confirm_new_password,
      };

      let updatePass_promise = null;
      if (payload.userId === this.$store.state.Profile.getUserId()) {
        updatePass_promise = ProfileService.updatePassword(payload);
      } else {
        updatePass_promise = UserService.setPassword(payload.userId, payload);
      }

      updatePass_promise.then(() => {
        showSuccessNotify(this, this.$t('pages.users.changePassword.successfullyChangedPassword'));
        return true;
      }).catch((error) => {
        showErrorPopup(this, error);
      }).finally(() => {
        this.old_password = '';
        this.new_password = '';
        this.confirm_new_password = '';
      });
    },
  },
};
</script>
